import { SET_AI_CHAT } from 'admin/constants/actions';

export type SetAiChatPayload = {
	open: boolean;
};

export function setAiChat(payload: SetAiChatPayload) {
	return { type: SET_AI_CHAT, payload };
}
